<template>
  <fragment>
    <b-overlay
      no-center
      :show="
        status === 'open' &&
          user.acceptStatus.toLowerCase() !== 'allowed' &&
          user.acceptStatus.toLowerCase() !== 'previous_payment_failure'
      "
    >
      <template #overlay>
        <PaymentFailed />
      </template>
      <b-card no-body>
        <div class="card-header">
          <b-alert show dismissible :variant="alertVariant" v-if="showAlert">
            <h3 class="alert-heading" v-if="alertTitle">{{ alertTitle }}</h3>
            <div v-html="alertMsg" />
          </b-alert>

          <!-- <div class="text-right">
            <b-button-group v-if="status === 'open' && !prePayment">
              <b-button
                variant="outline-success"
                v-b-modal="'modal_accept' + id"
                @click="acceptProject"
                :disabled="submitting"
              >
                <b-icon-check-circle></b-icon-check-circle>
                {{ $t('buttons.accept_request') }}
              </b-button>
            </b-button-group>
          </div> -->
          <b-icon-briefcase></b-icon-briefcase>
          {{ $t('project_details.project_details') }}
        </div>
        <b-list-group flush>
          <b-list-group-item>
            <b-badge
              pill
              variant="light"
              v-if="project.start_date_ISO"
              class="p-2 mr-2 projectBadge"
              ><b-icon
                icon="calendar2-date-fill"
                :aria-label="$t('project_details.startdate_label')"
                class="mr-1"
              />{{ $t('project_details.startdate_label_description') }}
              {{ project.start_date_ISO | dateReadable }}</b-badge
            >
            <b-badge
              pill
              variant="light"
              v-if="location"
              class="p-2 projectBadge"
              ><b-icon
                icon="geo-alt-fill"
                :aria-label="$t('table.header.location')"
                class="mr-1"
              />{{ location }}
              {{
                project.post_code ? ` - ${project.post_code.toUpperCase()}` : ''
              }}</b-badge
            >
            <p class="mt-2 mb-0" v-if="project.description">
              {{ project.description }}
            </p>
          </b-list-group-item>
          <b-list-group-item
            v-for="question in project.questions"
            :key="question.question"
          >
            <strong>{{ question.question }}</strong>
            {{ question.answer.join(' ') }}
          </b-list-group-item>
        </b-list-group>

        <b-card-footer v-if="status === 'open' || status === 'invalid'">
          <b-button-group class="controls">
            <b-button-group>
              <b-button
                v-if="status === 'open'"
                variant="outline-success"
                @click="acceptProject"
                :disabled="submitting"
              >
                <b-icon-check-circle></b-icon-check-circle>
                {{ $t('buttons.accept_request') }}
              </b-button>
            </b-button-group>
          </b-button-group>

          <b-button
            v-if="status === 'invalid'"
            variant="primary"
            @click="revertReportedStatus"
            :disabled="submitting"
          >
            {{ $t('buttons.add_quote') }}
          </b-button>

          <div class="mt-2">
            <fragment
              v-if="prePayment && status === 'open' && user.commissionOnly"
            >
              <small>{{ $t('project_details.prepayment_label') }}</small>
              <h3>
                {{ prePayment | currency(currency) }}
                <b-icon
                  icon="question-circle-fill"
                  v-b-modal="'modal_prepayment' + id"
                />
              </h3>
              <div>
                <b-link v-if="leadPrice" v-b-toggle.sidebar-refill-account>{{
                  $t('user.prepayment')
                }}</b-link>
              </div>
            </fragment>

            <fragment
              v-if="leadPrice && status === 'open' && !user.commissionOnly"
            >
              <h3>{{ leadPrice | currency(currency) }}</h3>
              <div>
                <b-link v-if="leadPrice" v-b-toggle.sidebar-refill-account>{{
                  $t('user.prepayment')
                }}</b-link>
              </div>
            </fragment>

            <small class="text-muted" v-if="status === 'open'">
              <i>{{
                $t(
                  `quote_form.disclaimer${
                    user.commissionOnly ? 'ComOnly' : ''
                  }`,
                  {
                    commission: provisionPercent,
                    days_left: daysLeft,
                    sum: this.$options.filters.currency(expireFee, currency),
                  },
                )
              }}</i>
            </small>
          </div>
        </b-card-footer>
      </b-card>
    </b-overlay>

    <b-modal
      :id="'modal_prepayment' + id"
      :title="$t('project_details.prepayment_title')"
    >
      <p class="m-2" v-html="$t('project_details.prepayment_description')" />

      <template v-slot:modal-footer="{ cancel }">
        <b-button
          class="float-right"
          @click="
            $router.push({
              name: 'Projects overview',
              params: {
                api_token,
                filter: 'quoted',
              },
            }),
              reloadPage()
          "
        >
          {{ $t('buttons.reportNewWins') }}
        </b-button>

        <b-button class="float-right" @click="cancel">
          {{ $t('buttons.close') }}
        </b-button>
      </template>
    </b-modal>
  </fragment>
</template>
<script>
import api from '../api/api';
import PaymentFailed from '@/components/PaymentFailed.vue';
import store from '../store/store';

export default {
  components: {
    PaymentFailed,
  },
  props: {
    id: {
      type: Number,
    },
    leadId: {
      type: Number,
    },
    status: {
      type: String,
    },
    location: {
      type: String,
    },
    currency: {
      type: String,
    },
    daysLeft: {
      type: Number,
      default: 0,
    },
    provisionPercent: {
      type: Number,
      default: 0,
    },
    expireFee: {
      type: Number,
      default: 0,
    },
    prePayment: {
      type: Number,
      default: 0,
    },
    leadPrice: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      project: [],
      api_token: sessionStorage.getItem('api_token'),
      submitting: false,
      showAlert: false,
      alertVariant: 'success',
      alertTitle: '',
      alertMsg: '',
    };
  },
  mounted() {
    this.getDetailedProject();
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    getDetailedProject() {
      api.getDetailedProject(this.id).then((res) => (this.project = res.data));
    },
    acceptProject() {
      this.submitting = true;

      api
        .acceptOpenProvisionLead(this.id)
        .then((res) => {
          if (res.data.success) {
            this.showAlert = true;
            this.alertTitle = this.$t('messages.success_title');
            this.alertMsg = this.$t('messages.success');

            this.$router.push({
              name: 'View lead',
              params: { id: res.data.provisionLeadId, method: 'edit' },
            });
            setTimeout(() => this.reloadPage(), 2000);
          } else {
            if (res.data.reason === 'already_accepted') {
              api.getAnsweredLead(this.id).then((lead) => {
                this.$router.push({
                  name: 'View lead',
                  params: { id: lead.data.provisionLead.id, method: 'edit' },
                });
                setTimeout(() => this.reloadPage(), 2000);
              });
            } else {
              this.$router.push({
                name: 'Invalid',
                params: { reason: res.data.reason },
              });
            }
          }
        })
        .catch(() => this.$store.dispatch('getUser')) //Probably payment error, update user object to show error message to user
        .finally(() => setTimeout(() => (this.submitting = false), 5000));
    },
    revertReportedStatus() {
      this.submitting = true;

      api
        .revertReportedStatus(this.leadId)
        .then(() => {
          this.$router.push({
            name: 'View lead',
            params: { id: this.leadId, method: 'edit' },
          });
          setTimeout(() => this.reloadPage(), 2000);
        })
        .catch((err) => err)
        .finally(() => setTimeout(() => (this.submitting = false), 5000));
    },
    reloadPage() {
      window && window.location.reload();
    },
  },
};
</script>
<style lang="scss" src="../assets/scss/projectForm.scss" scoped />
